import { useMyContext } from "../../ra-lb-tools/components/myContext";

export const shieldThreshold = 24;

export const getDefaultOptions = (lockers) => {
  const { acp } = useMyContext();
  const isSuperuser = acp.hasRoles("superuser");

  return {
    name: true,
    port: isSuperuser,
    shield: isSuperuser && lockers.length > shieldThreshold ? true : false,
    type: false,
    highlight_shield: 0,
    access: false,
    status: true,
    legend: isSuperuser,
    low: true,
    online: isSuperuser,
    ruler: "",
    proportional: true,
    box_angle: 45,
    box_depth: 50,
    unit: "inch",
    branded: 0,
    bg_src: "",
    bg_opacity: 70,
    bg_fit: "",
  };
};
